import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Link from "next/link";
import SwiperCore, { Autoplay, Pagination, EffectCoverflow } from "swiper/core";

import ProductCard from "../../Helpers/ProductCard";
import ArrowIcon from "@/components/icons/ArrowIcon";

SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);

const FrequentlyBoughtTogetherSwiper = ({
  frequentlyBoughtTogetherProducts,
  locale,
  t,
}) => {
  const [swiper, setSwiper] = useState({});
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  return frequentlyBoughtTogetherProducts?.length > 0 ? (
    <>
      <h3 className="mt-2 text-lg font-semibold px-4">
        {t("Frequently Bought Together")}
      </h3>
      <div className="relative mx-auto py-5 bg-white px-2">
        <Swiper
          onInit={setSwiper}
          key={locale}
          dir={locale === "ar" ? "rtl" : "ltr"}
          effect="coverflow"
          initialSlide={
            frequentlyBoughtTogetherProducts?.length % 2 === 0
              ? frequentlyBoughtTogetherProducts?.length / 2
              : 1
          }
          coverflowEffect={{
            rotate: 1,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          }}
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          breakpoints={{
            320: { slidesPerView: 1.69, spaceBetween: 20 },
            1280: { slidesPerView: 1.69, spaceBetween: 20 },
          }}
          centeredSlides
          className="frequentlyBoughtTogetherProductsSilder"
        >
          {frequentlyBoughtTogetherProducts?.map(({ _source }, key) => (
            <SwiperSlide key={key}>
              <Link href="#" className="relative overflow-hidden w-10">
                <ProductCard
                  {...{
                    t,
                    product: _source,
                    isShowCompareBtn: false,
                    fromCartInfo: true,
                  }}
                />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
        {swiper?.slides?.length > 2 && (
          <>
            {(locale === "ar" ? !isEnd : !isBeginning) && (
              <button
                onClick={() =>
                  locale === "ar" ? swiper?.slideNext() : swiper?.slidePrev()
                }
                aria-label="Prev Button"
                className="absolute z-50 top-1/2 left-5 w-7 h-7 bg-gray-400/60 rounded-full flex items-center justify-center text-tertiary-600 -translate-y-1/2"
              >
                <ArrowIcon className="text-gray-600 rotate-180 size-3" />
              </button>
            )}
            {(locale === "ar" ? !isBeginning : !isEnd) && (
              <button
                onClick={() =>
                  locale === "ar" ? swiper?.slidePrev() : swiper?.slideNext()
                }
                aria-label="Next Button"
                className="absolute z-50 top-1/2 right-5 w-7 h-7 bg-gray-400/60 rounded-full flex items-center justify-center text-tertiary-600 -translate-y-1/2"
              >
                <ArrowIcon className="text-gray-600 size-3" />
              </button>
            )}
          </>
        )}
      </div>
    </>
  ) : null;
};

export default FrequentlyBoughtTogetherSwiper;
